import { z } from "zod";
import { ExampleToneDefinitionId } from "../exampleToneDefinitions";
import { openAiSupportedLanguages } from "../openAiSupportedLanguages";

export const ToneDefinitionIdSchema = z.union([
  z.string().uuid(),
  z.nativeEnum(ExampleToneDefinitionId),
]);

export const ToneDefinitionSchema = z.object({
  id: ToneDefinitionIdSchema,
  organizationId: z.string().uuid(),
  createdAt: z.date(),
  removedAt: z.date().nullable(),

  title: z.string().min(3).max(128),
  positiveInstructions: z.string().min(3).max(2048),
  negativeInstructions: z.string().nullable(),
  language: z.string(),
});

export const CreateToneDefinitionSchema = ToneDefinitionSchema.pick({
  title: true,
  positiveInstructions: true,
}).merge(
  z.object({
    language: z.enum(openAiSupportedLanguages),
  }),
);

export const UpdateToneDefinitionSchema = z.object({
  title: CreateToneDefinitionSchema.shape.title.optional(),
  positiveInstructions:
    CreateToneDefinitionSchema.shape.positiveInstructions.optional(),
  language: CreateToneDefinitionSchema.shape.language.optional(),
});

export type ToneDefinition = z.infer<typeof ToneDefinitionSchema>;
export type CreateToneDefinition = z.infer<typeof CreateToneDefinitionSchema>;
export type UpdateToneDefinition = z.infer<typeof UpdateToneDefinitionSchema>;
